// RxLookup API endpoints and constants
export const RxLookupApiEndpoints = {
  Get: "api/RxLookup/Get",
  GetClaimDetailsData: "api/RxLookup/GetClaimDetailsData",
  GetCheckDetailsData: "api/RxLookup/GetCheckDetailsData",
  GetClaimLevelFeeAndAdjustmentsData:
    "api/RxLookup/GetClaimLevelFeeAndAdjustmentsData",
  GetMatchingData: "api/RxLookupMatching/GetMatchingData",
  MatchClaimsAndPayments: "api/RxLookupMatching/MatchClaimsAndPayments",
  UnmatchClaimsAndPayments: "api/RxLookupMatching/UnmatchClaimsAndPayments",
};

// Export individual endpoints for convenience
export const {
  Get: RX_LOOKUP_GET_ENDPOINT,
  GetClaimDetailsData: RX_LOOKUP_CLAIM_DETAILS_ENDPOINT,
  GetCheckDetailsData: RX_LOOKUP_CHECK_DETAILS_ENDPOINT,
  GetClaimLevelFeeAndAdjustmentsData: RX_LOOKUP_FEES_ADJUSTMENTS_ENDPOINT,
} = RxLookupApiEndpoints;
